export default {
    methods:{
        async recaptcha() {
            await this.$recaptchaLoaded()
            return await this.$recaptcha('login')
        }
    }
}